import type { ReportResponse, ReportRow } from "@grizzly/shared";
import { DataTable, type Column } from "../ui/dataTable.js";
import { useI18n } from "../../i18n/index.js";

interface AnyRow {
  id: string;
  [key: string]: string | number | boolean | null;
}

function toTableRows(rows: ReportRow[]): AnyRow[] {
  return rows.map((r, i) => ({ id: String(i), ...r }));
}

function toColumns(rows: ReportRow[]): Column<AnyRow>[] {
  return Object.keys(rows[0] ?? {}).map((key) => ({
    key,
    header: key,
    render: (r) => <span className="tabular">{String(r[key] ?? "")}</span>,
  }));
}

export function ReportTable({
  report,
  caption,
  loading,
  error,
}: {
  report: ReportResponse | null;
  caption: string;
  loading: boolean;
  error: string | null;
}) {
  const { t } = useI18n();
  const rows = toTableRows(report?.rows ?? []);
  const columns = toColumns(report?.rows ?? []);
  return (
    <DataTable
      caption={caption}
      rows={rows}
      rowKey={(r) => r.id}
      columns={columns}
      loading={loading}
      error={error ? { message: error } : null}
      emptyTitle={t("reports.noRows")}
      emptyDescription={t("reports.noRowsDesc")}
    />
  );
}
